import React, { useMemo } from 'react';
import { Icon } from '@Sage/hoi-poi-ui';

const useSmartFieldsGrid = ({ valueListItems, onConfigureValue, t }) => {
    const columns = useMemo(
        () => [
            {
                field: 'order',
                headerName: t('cfm_label_order'),
                cellRenderer: 'textCell',
                width: 90,
                resizable: true,
            },
            {
                field: 'description',
                headerName: t('cfm_label_description'),
                cellRenderer: 'textCell',
                resizable: true,
                flex: 1,
            },
            {
                field: 'id',
                headerName: t('cfm_label_id'),
                cellRenderer: 'textCell',
                width: 90,
                resizable: true,
            },
        ],
        [t],
    );

    const actions = useMemo(
        () => [
            (row) => ({
                icon: <Icon name="settings" onClick={() => onConfigureValue(row.id)} />,
                tooltip: { content: t('label_sf_config') },
            }),
        ],
        [onConfigureValue, t],
    );

    const rows = useMemo(() => {
        if (!valueListItems || valueListItems.length === 0) return [];

        return valueListItems.map((item) => ({
            id: item.value,
            order: item.order,
            description: item.label,
        }));
    }, [valueListItems]);

    return { columns, rows, actions };
};

export default useSmartFieldsGrid;
